import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '../api/client'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        // Never retry what will fail again: auth, authorization, validation,
        // and missing resources are all terminal for the current request.
        if (error instanceof ApiError && error.status < 500 && error.status !== 429) {
          return false
        }
        return failureCount < 2
      },
    },
    mutations: { retry: false },
  },
})
